import { Platform } from 'react-native'

export const blobToBase64 = (blob: Blob, mimeType?: string): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    // readAsDataURL builds the data: prefix from the blob's own type, so retype it to force the desired mime
    const source = mimeType ? new Blob([blob], { type: mimeType }) : blob
    reader.onload = () => {
      resolve(reader.result as string)
    }
    reader.onerror = reject
    reader.readAsDataURL(source)
  })

export const getUrlFromBlob = async (blob: Blob, mimeType?: string): Promise<string> => {
  if (Platform.OS === 'web') {
    return URL.createObjectURL(blob)
  } else {
    return await blobToBase64(blob, mimeType)
  }
}
